import { Action } from 'redux';

import { SetContact } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../models/IContentInfo';

export interface SetContactAction extends Action {
  item: IContentInfo;
}

export function setContactAction(item: IContentInfo): SetContactAction {
  return {
    type: SetContact,
    item
  };
}
